import { walk } from '../utils';
import { cleanImageTextFromElement } from '@intercom/composer-ember/lib/config/specs/nodes/image-text-spec';
export function matches(html) {
  return /intercom-interblocks/.test(html);
}
export function clean(root) {
  let nodesToSkip = ['UL', 'OL'];

  // When copy-pasting `image-text` block, the logic below will result in 3 different
  // blocks being created: one with the image, one with the text, and one with the description.
  // This function ensures that `image-text` blocks are removed from the pasted dom tree.
  cleanImageTextFromElement(root);
  walk(root, nodesToSkip, node => {
    if (node.nodeName === 'DIV') {
      let element = node;
      if (element.classList.contains('intercom-interblocks-paragraph') && !element.classList.contains('no-margin') && element.nextSibling) {
        element.classList.add('no-margin');
        let div = document.createElement('div');
        div.classList.add('intercom-interblocks-paragraph');
        div.classList.add('no-margin');
        let paragraph = document.createElement('p');
        div.appendChild(paragraph);
        element.parentNode?.insertBefore(div, element.nextSibling);
      }
    }
  });
  return root;
}